"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var react_1 = require("@emotion/react");

var CounterWrapper = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50%;\n\tposition: relative;\n\tright: 15%;\n\ttop: -7px;\n\n\t", ";\n"])), function (props) {
  var size = props.size,
      borderColor = props.borderColor,
      backgroundColor = props.backgroundColor,
      badgeContent = props.badgeContent;
  var contentLength = badgeContent && badgeContent.length;
  var grow = contentLength === 2 ? 2 : contentLength === 3 ? 4 : 0;
  var dimension = size === "sm" ? 16 : size === "lg" ? 20 : 18;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t\twidth: ", ";\n\t\t\theight: ", ";\n\t\t\tright: 20%;\n\t\t\ttop: -10px;\n\t\t\tborder: 1px solid ", ";\n\t\t"])), backgroundColor, dimension + grow + "px", dimension + grow + "px", borderColor);
});
var NotificationWrapper = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n"])));
var BadgeWrapper = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n\twidth: fit-content;\n\theight: 30px;\n\tpadding: 15px;\n\tborder-radius: 60px;\n\t", ";\n"])), function (props) {
  var backgroundColor = props.backgroundColor,
      breakpoint = props.breakpoint;
  return (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\t@media only screen and (min-width: ", ") {\n\t\t\t\tpadding: 17px;\n\t\t\t}\n\t\t"])), backgroundColor, breakpoint);
});
var BadgeColor = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\twidth: 6px;\n\theight: 6px;\n\tborder-radius: 10px;\n\n\t", ";\n"])), function (props) {
  var lighterGray = props.lighterGray,
      breakpoint = props.breakpoint,
      color = props.color;
  return (0, react_1.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t\t@media only screen and (min-width: ", ") {\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t}\n\t\t"])), color || lighterGray, breakpoint);
});

var addWidth = function addWidth(props) {
  return (0, react_1.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\twidth: 16px;\n\t@media only screen and (min-width: ", ") {\n\t\twidth: 18px;\n\t}\n"])), props.breakpoint);
};

var BadgeContent = styled_1.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t", ";\n"])), function (props) {
  var size = props.size,
      white = props.white;
  return (0, react_1.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t"])), white, size === "sm" ? "7px" : size === "lg" ? "11px" : "9px");
});

var Badge = function Badge(_ref) {
  var background = _ref.background,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      badgeContent = _ref.badgeContent,
      size = _ref.size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$badgeType = _ref.badgeType,
      badgeType = _ref$badgeType === void 0 ? "pill" : _ref$badgeType,
      onClick = _ref.onClick;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      primaryBrand = _theme$colors$primary.primaryBrand,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      darkGray = _theme$colors$primary.darkGray,
      gray = _theme$colors$primary.gray;
  var breakpoint = theme.breakpoints.lg;
  var backgroundColor = background ? background : badgeType === "notification" ? theme.colors[type].background : type === "tertiary" ? white : type === "secondary" ? gray : lighterGray;
  var badgeColor = color ? color : type === "tertiary" ? darkGray : type === "secondary" ? secondaryBrand : primaryBrand;
  return badgeType === "pill" ? (0, jsx_runtime_1.jsxs)(BadgeWrapper, {
    className: className,
    backgroundColor: backgroundColor,
    breakpoint: breakpoint,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: addWidth({
        breakpoint: theme.breakpoints.lg
      }),
      children: (0, jsx_runtime_1.jsx)(BadgeColor, {
        lighterGray: lighterGray,
        breakpoint: breakpoint,
        color: color
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: type === "secondary" && "white",
        children: children
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "sm",
        color: type === "secondary" && "white",
        children: children
      })
    })]
  }) : (0, jsx_runtime_1.jsxs)(NotificationWrapper, {
    className: className,
    onClick: onClick,
    children: [children, badgeContent && badgeContent !== "0" && (0, jsx_runtime_1.jsx)(CounterWrapper, {
      backgroundColor: badgeColor,
      borderColor: backgroundColor,
      size: size,
      badgeContent: badgeContent,
      children: (0, jsx_runtime_1.jsx)(BadgeContent, {
        white: white,
        size: size,
        children: badgeContent
      })
    })]
  });
};

exports.Badge = Badge;